import { render, staticRenderFns } from "./proficiency-matrix.vue?vue&type=template&id=7b65cf15&"
import script from "./proficiency-matrix.ts?vue&type=script&lang=ts&"
export * from "./proficiency-matrix.ts?vue&type=script&lang=ts&"
import style0 from "./proficiency-matrix.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports